import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import AuthService from "../../../Service/auth.service";
import { useLoader } from "../../../Context/LoaderContext";
import Loader from "../../../Components/Loader";

const GoogleCalendarAuth = () => {
  let [searchparams] = useSearchParams();
  const token = searchparams.get("code");
  const navigate = useNavigate();
  const { setLoading } = useLoader();

  useEffect(() => {
    const sendTokenToServer = async () => {
      setLoading(true);
      try {
        if (token !== null) await AuthService.getInstance().sendToken(token);
        setTimeout(() => {
          navigate("/interview-settings?authSuccess=true");
        }, 500);
      } catch (err) {
        console.error("Calendar auth redirect page error: ", err);
        setTimeout(() => {
          navigate("/interview-settings?authSuccess=false");
        }, 500);
      } finally {
        setLoading(false);
      }
    };
    sendTokenToServer();
  }, [token]);
  return (
    <>
      <Loader isLoading={true} loadingMessage={"Authenticating please wait..."} />
    </>
  );
};

export default GoogleCalendarAuth;
